import { create } from "zustand";

// Lightweight global toasts. Actions (Save, etc.) acknowledge with a transient
// notification instead of failing silently. Fire from anywhere — including
// non-React code like a mutation's onSuccess — via the `toast` helper below.

export type ToastVariant = "success" | "error" | "info";
export interface Toast { id: number; message: string; variant: ToastVariant; }

interface ToastState {
  toasts:  Toast[];
  push:    (message: string, variant?: ToastVariant) => void;
  dismiss: (id: number) => void;
}

let seq = 0;
const DURATION_MS = 3200;

export const useToastStore = create<ToastState>((set, get) => ({
  toasts: [],
  push: (message, variant = "success") => {
    const id = ++seq;
    set((s) => ({ toasts: [...s.toasts, { id, message, variant }] }));
    setTimeout(() => get().dismiss(id), DURATION_MS);
  },
  dismiss: (id) => set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) })),
}));

/** Fire a toast imperatively (works outside React, e.g. react-query callbacks). */
export const toast = {
  success: (m: string) => useToastStore.getState().push(m, "success"),
  error:   (m: string) => useToastStore.getState().push(m, "error"),
  info:    (m: string) => useToastStore.getState().push(m, "info"),
};
